module.exports = __webpack_public_path__ + "static/media/time.3b5e17ca.svg";